import { Margin } from 'components/base/layout-components';
import svgLogo from 'images/logos/linearb-logo.svg';
import UserProfile from 'connected-components/ProfilePanel';
import {
  StyledTopBar,
  StyledLogoWrapper,
  StyledLogo
} from './LockedTopBar.style';

export const LockedTopBar = () => {
  return (
    <StyledTopBar>
      <StyledLogoWrapper>
        <StyledLogo src={svgLogo} />
      </StyledLogoWrapper>
      <Margin r='large'>
        <UserProfile />
      </Margin>
    </StyledTopBar>
  );
};
